import { Cookie } from "@modules/util/Cookie"
import { updateUrl } from "@modules/util/url"

const orderedAdvertsCookie = new Cookie("orderedAdvertsConfig", {
    path: "/",
    domain: SiteInfo.cookieDomain,
})

document.addEventListener("mousedown", (event) => {
    const cardWithNextPreviousId = getNextPreviousCard(event)

    if (!cardWithNextPreviousId) {
        return null
    }

    let pageElement = cardWithNextPreviousId.previousElementSibling
    while (!pageElement?.hasAttribute("data-page") && pageElement !== null) {
        pageElement = pageElement?.previousElementSibling || null
    }
    const page = pageElement?.getAttribute("data-page")
    if (page) {
        const newUrl = new URL(window.location.href)
        newUrl.searchParams.set("page", page)
        updateUrl(newUrl.href)
    }

    const previousNextId = cardWithNextPreviousId.getAttribute("data-next-previous-id")
    orderedAdvertsCookie.expires = Cookie.getExpireDate(3600 * 24)
    orderedAdvertsCookie.value = {
        currentOrderedId: previousNextId,
        currentOrderedReferrer: "contentcatalog-anzeigenmarkt",
        currentBacklinkAdvertUrl: window.location.href,
    }
})

document.addEventListener("click", (event) => {
    const cardWithNextPreviousId = getNextPreviousCard(event)

    if (!cardWithNextPreviousId) {
        return null
    }

    localStorage.setItem("scrollToPreviousNextId", cardWithNextPreviousId.getAttribute("data-next-previous-id") || "")
})

function getNextPreviousCard(event: Event) {
    let cardWithNextPreviousId = null
    for (const element of event.composedPath()) {
        if (element instanceof HTMLElement && element.hasAttribute("data-next-previous-id")) {
            cardWithNextPreviousId = element
            break
        }
    }

    if (!cardWithNextPreviousId) {
        return null
    }
    return cardWithNextPreviousId
}
